<template>
  <div class="animation">
    <!-- <md-progress-spinner class="md-accent" :md-diameter="20" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner> -->
    <span class="md-accent">

      <div class="loader">
        Loading...
        <div class="square" ></div>
        <div class="square"></div>
        <div class="square last"></div>
        <div class="square clear"></div>
        <div class="square"></div>
        <div class="square last"></div>
        <div class="square clear"></div>
        <div class="square "></div>
        <div class="square last"></div>
      </div>

    </span>
    <div id="bg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped>
#bg{
  position: fixed;
  width: 100%;
  height: 100%;
  background:rgba(0,0,0,.4);
  z-index: 999;
}
.loader{
  position: absolute;
  color:white;
  z-index: 1000;
  margin: 25% 50%;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue